import React, { memo } from 'react';
import { createUseStyle } from '@redlink/assets/styles';
import { Space, WrapListContainer } from '@redlink/components/atoms';
import { ThemeItem } from '@redlink/components/muscles';

export const ThemeList = memo(
  ({
    onPress,
    data,
    style,
    onEditPress,
    onSetAsDefaultPress,
    onDeletePress,
  }) => {
    const { styles } = useStyle();

    return (
      <WrapListContainer {...{ style }}>
        {data.map((item, index) => {
          return (
            <>
              <ThemeItem
                style={styles.itemContainer}
                {...{ item }}
                onPress={() => onPress && onPress(item, index)}
                onEditPress={() => onEditPress && onEditPress(item, index)}
                onSetAsDefaultPress={() =>
                  onSetAsDefaultPress && onSetAsDefaultPress(item, index)
                }
                onDeletePress={() =>
                  onDeletePress && onDeletePress(item, index)
                }
              />
              <Space />
            </>
          );
        })}
      </WrapListContainer>
    );
  }
);

const useStyle = createUseStyle(({ colors, shadow, size }) => ({
  itemContainer: {
    width: 208,
    marginVertical: 8,
  },
  thumbnaleContainer: {
    width: 64,
    height: 64,
    borderRadius: 32,
    padding: 20,
    backgroundColor: colors.white2,
  },
}));
